/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSize } from '../../factoriesAny.js';
export var sizeDependencies = {
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createSize: createSize
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSize.generated.js
// module id = 58
// module chunks = 0